import { render, staticRenderFns } from "./SpfiUpdate.vue?vue&type=template&id=43990dff&scoped=true"
import script from "./SpfiUpdate.vue?vue&type=script&lang=js"
export * from "./SpfiUpdate.vue?vue&type=script&lang=js"
import style0 from "./SpfiUpdate.vue?vue&type=style&index=0&id=43990dff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43990dff",
  null
  
)

export default component.exports